<template>
  <section class="checkout-payment-step">
    <nav class="checkout-payment-step__nav-tabs"
      v-if="couponFeatureAvailable">
      <a @click="selectTab(1)"
        class="checkout-payment-step__nav-tabs__item"
        :class="{
          'checkout-payment-step__nav-tabs__item--active': (this.tabSelected === 1)
        }"
      >
        {{ $t('checkout.payment.navTabs.itemCard') }}
      </a>
      <a @click="selectTab(2)"
        class="checkout-payment-step__nav-tabs__item"
        :class="{
          'checkout-payment-step__nav-tabs__item--active': (this.tabSelected === 2)
        }"
      >
        {{ $t('checkout.payment.navTabs.itemCoupon') }}
      </a>
    </nav>
    <div class="checkout-payment-step__nav-container">
      <form class="checkout-payment-step__nav-container__form" @submit.prevent="submit" novalidate autocomplete="off">
        <transition name="fade" mode="out-in">
          <div v-if="this.tabSelected === 1">
            <div id="checkout-pagamento-título" class="checkout-payment-step__nav-container__form__header">
              <h1 v-html="$t('checkout.payment.cardTab.title')"></h1>
              <p v-html="$t('checkout.payment.cardTab.description')"></p>
            </div>
            <div class="checkout-payment-step__nav-container__form__body">
              <div>
                <h3 class="checkout-payment-step__nav-container__form__body__section-title">
                  {{ $t('checkout.payment.cardTab.form.personalSection.title') }}
                </h3>
                <pk-input
                  v-model="billing.cpf"
                  :placeholder="$t('checkout.payment.cardTab.form.personalSection.documentLabel')"
                  mask="###.###.###-##" :error="$v.billing.cpf.$error" type="tel" ref="cpf" />
                <pk-input
                  v-model="billing.zipcode"
                  :placeholder="$t('checkout.payment.cardTab.form.personalSection.addressZipCodeLabel')"
                  mask="#####-###" :error="$v.billing.zipcode.$error" @input="searchZipcode" type="tel" />
                <div class="checkout-payment-step__nav-container__form__body__input-group">
                  <pk-input
                    v-model="billing.address"
                    :placeholder="$t('checkout.payment.cardTab.form.personalSection.addressLabel')"
                    :error="$v.billing.address.$error" lass="x60"/>
                  <pk-input
                    v-model="billing.number"
                    :placeholder="$t('checkout.payment.cardTab.form.personalSection.addressNumberLabel')"
                    :error="$v.billing.number.$error" class="x40 padding-left-2" />
                </div>
                <div class="checkout-payment-step__nav-container__form__body__input-group">
                  <pk-input
                    v-model="billing.district"
                    :placeholder="$t('checkout.payment.cardTab.form.personalSection.addressDistrictLabel')"
                    :error="$v.billing.district.$error" class="x60" />
                  <pk-input
                    v-model="billing.additionalDetails"
                    :placeholder="$t('checkout.payment.cardTab.form.personalSection.addressComplementLabel')"
                    class="x40 padding-left-2" />
                </div>
                <div class="checkout-payment-step__nav-container__form__body__input-group">
                  <pk-input
                    v-model="billing.city"
                    :placeholder="$t('checkout.payment.cardTab.form.personalSection.addressCityLabel')"
                    :error="$v.billing.city.$error" class="x60" />
                  <pk-input
                    v-model="billing.state"
                    :placeholder="$t('checkout.payment.cardTab.form.personalSection.addressStateLabel')"
                    mask="NN" :error="$v.billing.state.$error" class="x40 padding-left-2" />
                </div>
              </div>

              <h3 class="checkout-payment-step__nav-container__form__body__section-title">
                {{ $t('checkout.payment.cardTab.form.paymentSection.title') }}
              </h3>
              <pk-input
                v-if="isEmailFieldVisible" v-model="email"
                :placeholder="$t('checkout.payment.cardTab.form.paymentSection.emailLabel')"
                :error="$v.email.$error" />
              <pk-input
                v-model="card.number"
                :placeholder="$t('checkout.payment.cardTab.form.paymentSection.cardNumberLabel')"
                mask="#### #### #### ####" :error="$v.card.number.$error" type="tel" ref="cardNumber" />
              <pk-input
                v-model="card.holderName"
                :placeholder="$t('checkout.payment.cardTab.form.paymentSection.cardHolderNameLabel')"
                :mask="'N'.repeat(26)" :error="$v.card.holderName.$error" />
              <div class="checkout-payment-step__nav-container__form__body__input-group">
                <pk-input
                  v-model="card.expirationMonth"
                  :placeholder="$t('checkout.payment.cardTab.form.paymentSection.cardExpirationMonthLabel')"
                  mask="##" :error="$v.card.expirationMonth.$error" type="tel" class="x50" />
                <pk-input
                  v-model="card.expirationYear"
                  :placeholder="$t('checkout.payment.cardTab.form.paymentSection.cardExpirationYearLabel')"
                  mask="####" :error="$v.card.expirationYear.$error" type="tel" class="x50 padding-left-2" />
                <pk-input
                  v-model="card.cvv"
                  :placeholder="'CVV'"
                  mask="###" :error="$v.card.cvv.$error" type="tel" class="x40 padding-left-2" />
              </div>
            </div>
            <div class="checkout-payment-step__nav-container__form__body__card">
              <credit-card-component
                :cardNumber="this.card.number"
                :cardHolderName="this.card.holderName"
                :cardExpirationMonth="this.card.expirationMonth"
                :cardExpirationYear="this.card.expirationYear"
                :cardCVV="this.card.cvv"
              />
            </div>
            <btn color="purple"
              @click="createSubscription"
              class="checkout-payment-step__nav-container__form__button"
            >
              {{ cta.title }}
            </btn>
          </div>
          <div v-else>
            <div class="checkout-payment-step__nav-container__form__header">
              <h1 v-html="$t('checkout.payment.couponTab.title')"></h1>
              <p v-html="$t('checkout.payment.couponTab.description')"></p>
              {{ this.coupon }}
            </div>
            <div class="checkout-payment-step__nav-container__form__body">
              <div class="checkout-payment-step__nav-container__form__body__coupon-input-card">
                <div class="checkout-payment-step__nav-container__form__body__coupon-input-card__plan">
                  <span>{{ $t('checkout.payment.couponTab.form.couponLabel') }}</span>
                </div>
                <pk-input
                  :placeholder="$t('checkout.payment.couponTab.form.couponInput')"
                  type="text" />
              </div>
            </div>
            <btn color="purple"
              @click="createSubscription"
              :loading="processing"
              class="checkout-payment-step__nav-container__form__button"
              id="checkout-pagamento-cta-4-pagamento"
            >
              {{ cta.title }}
            </btn>
          </div>
        </transition>
      </form>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import appboy from 'appboy-web-sdk'
import { required, numeric, minLength, maxLength, between, email } from 'vuelidate/lib/validators'
import viacepAPI from '@/api/viacep'
import validatorMixin from '@/js/mixins/validator'
import { creditCard, cpf } from '@/js/validationUtils'
import checkoutCtas from '@/js/checkoutCtas'
import CreditCardComponent from '../../misc/CreditCardComponent.vue'

const exactLength = (length) => ({
  minLength: minLength(length),
  maxLength: maxLength(length)
})

const setBillingInfo = (property, billingObject, viacepData) => {
  if (!billingObject[property]) {
    billingObject[property] = viacepData[property]
  }
}

export default {
  components: { CreditCardComponent },
  name: 'checkout-payment-step',
  mixins: [validatorMixin],
  props: {
    processing: Boolean,
    coupon: String,
    plan: Object,
    credentialKey: String
  },
  data: () => ({
    tabSelected: 1,
    couponFeatureAvailable: false,
    email: null,
    cpf: '',
    card: {
      number: '',
      holderName: '',
      expirationMonth: '',
      expirationYear: '',
      cvv: ''
    },
    billing: {
      cpf: '',
      address: '',
      city: '',
      district: '',
      number: '',
      state: '',
      zipcode: '',
      additionalDetails: ''
    }
  }),
  validations() {
    const validations = {
      email: { required, email },
      card: {
        number: { required, numeric, creditCard, ...exactLength(16) },
        holderName: { required, minLength: minLength(4) },
        expirationMonth: { required, numeric, between: between(1, 12) },
        expirationYear: { required, numeric, ...exactLength(4) },
        cvv: { required, numeric, ...exactLength(3) }
      },
      billing: {
        cpf: { required, numeric, cpf, ...exactLength(11) },
        address: { required },
        city: { required },
        district: { required },
        number: { required },
        state: { required, ...exactLength(2) },
        zipcode: { required, ...exactLength(8) }
      }
    }

    if (!this.isEmailFieldVisible) {
      delete validations.email
    }

    return validations
  },
  computed: {
    planPrice() {
      if (this.plan) {
        return `${this.plan.currency} ${this.plan.price}`
      }
      return 'XX,XX'
    },
    cta() {
      return checkoutCtas().payment
    }
  },
  methods: {
    ...mapState({
      signedInPlatform: state => state.user.signedInPlatform,
      accountId: state => state.user.accountId,
      facebookEmail: state => state.authentication.facebookEmail
    }),
    selectTab(index) {
      this.tabSelected = index
    },
    isEmailFieldVisible() {
      return this.signedInPlatform === 'FACEBOOK' && !this.facebookEmail
    },
    async searchZipcode() {
      if (this.billing.zipcode.length !== 8) {
        return
      }

      const data = await viacepAPI.searchZipcode(this.billing.zipcode)
      setBillingInfo('address', this.billing, data)
      setBillingInfo('city', this.billing, data)
      setBillingInfo('district', this.billing, data)
      setBillingInfo('state', this.billing, data)
    },
    createSubscription() {
      if (!this.isValid()) {
        return
      }

      this.$emit('subscriptionCreationRequested', {
        email: this.email || this.facebookEmail,
        card: { ...this.card },
        billing: { ...this.billing }
      })
    }
  },
  mounted() {
    appboy.logCustomEvent('Reached Payment Page')
    this.email = this.credentialKey
  }
}
</script>

<style lang="scss">
@mixin input-width($amount) {
  flex-basis: $amount;
  width: $amount;
}

.checkout-payment-step {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: 8rem;
  padding-top: 9.5rem;

  &__nav-tabs {
    display: flex;
    min-width: 100%;
    margin-bottom: 3rem;
    &__item {
      width: 325px;
      background-color: #F7F7F7;

      font-family: Nunito;
      font-style: normal;
      font-weight: 900;
      font-size: 16px;
      line-height: 16px;

      padding-top: 1.75rem;
      padding-bottom: 1.75rem;
      text-decoration: none;
      text-align: center;

      &--active {
        color: #6253BC;
        border-bottom: 6px solid #6253BC;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    }
  }

  &__nav-container {
    display: flex;

    &__form {
      min-width: 100%;

      &__header {
        min-width: 100%;
        margin-bottom: 2rem;
        h1 {
          font-family: Nunito;
          font-style: normal;
          font-weight: 900;
          font-size: 26px;
          line-height: 32px;
          color: #443D4B;
        }
        p {
          font-family: Nunito;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
          color: #454545;
        }
      }

      &__body {
        min-width: 100%;
        &__section-title {
          font-size: 16px;
          line-height: 20px;
          margin-bottom: 2rem;
        }

        .pk-input {
          @include input-width(100%);
          margin-bottom: 2rem;

          &.x60 {
            @include input-width(60%);
          }

          &.x50 {
            @include input-width(50%);
          }

          &.x40 {
            @include input-width(40%);
          }
          &.padding-left-2 {
            padding-left: 2rem;
          }
        }

        &__description {
          text-align: justify;
          font-family: Nunito;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 20px;
          color: #454545;
        }

        &__input-group {
          display: flex;
        }

        &__coupon-input-card {
          display: flex;
          align-items: center;
          width: 100%;
          height: 136px;
          background-color: #fff;
          border-radius: 16px;
          box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
          margin-top: 4rem;
          margin-bottom: 2rem;
          padding-right: 2rem;
          &__plan {
            display: flex;
            align-items: center;
            padding-left: 1rem;;
            width: 30%;
            min-width: 30%;
            height: 100%;
            margin-right: 2rem;
            background-color: #F3F7FA;

            span {
              font-family: Nunito;
              font-style: normal;
              font-weight: 900;
              font-size: 16px;
              line-height: 20px;
              color: #A217AB;
            }
          }
          &__input {
            margin-left: 2rem;
            margin-right: 2rem;
            margin-bottom: 0;
          }
        }
        &__card {
          display: none;
        }
      }

      &__button.btn {
        min-width: 100%;
        margin-top: 4rem;
      }
    }
  }
}
@media screen and (min-width: 641px) {
  .checkout-payment-step {
    padding-top: 10rem;
    &__nav-container {
      &__form {
        min-width: 464px;
        max-width: 464px;
        &__header {
          min-width: 600px;
          max-width: 600px;
          h1 {
            font-size: 34px;
            line-height: 34px;
          }
          p {
            font-size: 16px;
            line-height: 20px;
          }
        }
        &__body {
          &__section-title {
            font-size: 18px;
            line-height: 22px;
          }
          &__card {
            display: none;
          }
        }
      }
    }

    &__nav-tabs {
      &__item {
        font-size: 20px;
        line-height: 20px;
      }
    }
  }
}
@media screen and (min-width: 769px) {
  .checkout-payment-step {
    padding-top: 10rem;
    &__nav-container {
      &__form {
        &__header {
          h1 {
            font-size: 39.81px;
            line-height: 40px;
          }
          p {
            font-size: 19.2px;
            line-height: 24px;
          }
        }
        &__body {
          &__section-title {
            font-size: 22px;
            line-height: 28px;
          }
        }
      }
    }

    &__nav-tabs {
      &__item {
        font-size: 23.04px;
        line-height: 27px;
      }
    }
  }
}
@media screen and (min-width: 1025px) {
  .checkout-payment-step {
    padding-top: 10rem;
    &__nav-container {
      &__form {
        &__body {
          &__card {
            position: absolute;
            display: block;
            left: 520px;
            bottom: 10rem;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1281px) {
  .checkout-payment-step {
    padding-top: 10rem;
  }
}
</style>
